import React from 'react'

const ProfileComponent = () => {
  return (
    <div>ProfileComponent</div>
  )
}

export default ProfileComponent